import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { MTableToolbar } from 'material-table';
import { exportCsv } from '../../helpers/functions';


const FaconTable = ({ data }) => {
    const columns = [
        { title: 'Client', field: 'client', align: 'left', defaultSort: null },
        { title: 'Date', field: 'df', align: 'left', defaultSort: null },
        { title: 'N° Facture', field: 'fact', align: 'left', defaultSort: null, type: 'numeric' },
        { title: 'Référence', field: 'ref', align: 'left', defaultSort: null, type: 'numeric' },
        { title: 'Réf Client', field: 'ref_clt', align: 'left', defaultSort: null, type: 'numeric' },
        { title: 'Poids Or', field: 'poids', align: 'left', defaultSort: null, type: 'numeric' },

    ]
    const [poidsTotal, setPoidsTotal] = useState(0);
    const [nbSelection, setNbSelection] = useState(0);
    const [poidsSelectionne, setPoidsSelectionne] = useState(0);


    useEffect(() => {
        let total = 0;
        data.forEach(item => {
            total += parseFloat(item.poids);
        });
        setPoidsTotal(total);
    }, [data]);

    const calculateTotalSelected = () => {
        let totalSelection = 0, nbSelection = 0;
        Object.values(data)
            .filter(f => f.tableData.checked)
            .forEach(item => {
                if (item.tableData.checked) {
                    totalSelection += parseFloat(item.poids);
                    nbSelection++;
                }
            });
        setPoidsSelectionne(totalSelection);
        setNbSelection(nbSelection);
    }
    const printFact = (rowData) => {
        let ids = '', sep = ''
        Object.values(rowData).forEach(fact => {
            ids += sep + fact.fact
            sep = ','
        })
        window.open(`https://www.extensia-france.com/printers/factPrinter2024.php?listeFact=${ids}`, "_blank")
    }

    return (
        <div>
            {poidsTotal !== 0 && (
                <h5 className="d-flex justify-content-around">Poids Total : {poidsTotal} Gr</h5>
            )}
            <MaterialTable
                style={{ fontSize: 12 }}
                columns={columns}
                options={{
                    showTextRowsSelected: false,
                    pageSize: 10,
                    selection: true,
                    actionsColumnIndex: -1,
                    exportButton: true,
                    exportAllData: true,
                    exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "facon"),
                    pageSizeOptions: [10, 20, 30, 100],
                    padding: 'dense',
                }}
                actions={[
                    rowData => ({
                        icon: 'picture_as_pdf',
                        tooltip: 'Imprimer Facture',
                        onClick: () => printFact(rowData),
                        position: 'toolbarOnSelect',
                    }),
                    {
                        icon: 'picture_as_pdf',
                        tooltip: 'Imprimer Facture',
                        onClick: (e, rowData) => window.open(`https://www.extensia-france.com/printers/factPrinter2024.php?listeFact=${rowData.fact}`, "_blank"),
                        position: 'row',
                    }
                ]}
                onSelectionChange={calculateTotalSelected}
                data={[...data]}
                title=" "
                components={{
                    Toolbar: props => (
                        <div>
                            <MTableToolbar {...props} />
                            {<div className="d-flex justify-content-around">

                                <h5>{'Sélectionné(s) : ' + nbSelection}</h5>
                                <h5>{'Total Sélectionné : ' + poidsSelectionne}</h5>
                            </div>}
                        </div>
                    ),
                }}
            />
        </div>

    );
}

export default FaconTable;
